/**
 * Add backwards compatibility for consumers using `require` syntax. New SDKs should *NOT* follow this pattern, and instead
 * export the sdk directly, e.g. `module.exports = require('./dist/my-sdk');`
 */
const provideRequireCompat = require('./provide-require-compat');
module.exports = provideRequireCompat(require('./dist/service-sdk'));
